import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Zap, Mail, Lock, Eye, EyeOff, ShieldCheck, Briefcase, LogIn,
} from 'lucide-react';
import { entreprise } from '../data/mockData';

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [showPwd, setShowPwd] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const connecter = (role) => {
    onLogin(role);
    navigate(role === 'client' ? '/espace-client' : '/');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const role = email.toLowerCase().includes('client') || email.toLowerCase().includes('@grandlyon')
      ? 'client'
      : 'admin';
    connecter(role);
  };

  return (
    <div className="login-page">
      <div className="login-illustration">
        <div className="login-illustration-content">
          <div className="login-brand">
            <div className="brand-icon-wrapper">
              <Zap size={22} />
            </div>
            <div>
              <h2>{entreprise.nom}</h2>
              <p>{entreprise.slogan}</p>
            </div>
          </div>
          <div className="login-separator" />
          <p className="login-description">
            Plateforme ERP de gestion de stock, de tracabilite et de suivi de
            projets electriques TP. Acces interne pour les equipes ITNI et
            espace client dedie pour le suivi de vos projets en autonomie.
          </p>
          <ul className="login-features">
            <li>
              <span className="dot" />
              <span>Tracabilite complete : commande, BL, numero de serie, chantier</span>
            </li>
            <li>
              <span className="dot" />
              <span>Pieces jointes structurees sur chaque commande fournisseur</span>
            </li>
            <li>
              <span className="dot" />
              <span>Espace client : informations projet + documents partages</span>
            </li>
            <li>
              <span className="dot" />
              <span>Cycle complet : creation, depart usine, reception, installation</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="login-form-wrapper">
        <div className="login-form">
          <h1>Connexion</h1>
          <p>Acces a votre espace ITNI</p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Adresse email</label>
              <div className="input-wrapper">
                <Mail size={16} />
                <input
                  id="email"
                  type="email"
                  placeholder="prenom.nom@itni.fr"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <div className="input-wrapper">
                <Lock size={16} />
                <input
                  id="password"
                  type={showPwd ? 'text' : 'password'}
                  placeholder="********"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPwd((v) => !v)}
                  title={showPwd ? 'Masquer' : 'Afficher'}
                >
                  {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" className="btn-primary btn-block">
              <LogIn size={16} /> Se connecter
            </button>
          </form>

          <div className="login-shortcuts">
            <div className="login-shortcuts-sep">
              <span>ou demonstration</span>
            </div>
            <div className="login-shortcuts-buttons">
              <button
                type="button"
                className="btn-shortcut btn-shortcut-admin"
                onClick={() => connecter('admin')}
              >
                <ShieldCheck size={18} />
                <div>
                  <strong>Acces demo administrateur</strong>
                  <span>Vue complete ITNI - pilotage et configuration</span>
                </div>
              </button>
              <button
                type="button"
                className="btn-shortcut btn-shortcut-client"
                onClick={() => connecter('client')}
              >
                <Briefcase size={18} />
                <div>
                  <strong>Acces demo client</strong>
                  <span>Espace dedie - suivi de vos projets et documents</span>
                </div>
              </button>
            </div>
          </div>

          <p className="login-footer">
            Probleme de connexion ? Contactez le support a
            <a href="mailto:support@itni.fr"> support@itni.fr</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
